import type { FC } from 'react';

import {
    IconDefaultCheckbox,
    IconDisabledCheckbox,
    IconSelectedDisabledCheckbox,
    IconSelectedCheckbox,
} from './icons';

interface IPseudoCheckbox {
    checked: boolean;
    disabled: boolean;
}

export const PseudoCheckbox: FC<IPseudoCheckbox> = ({ checked, disabled }) => {
    if (checked) {
        return disabled ? IconSelectedDisabledCheckbox : IconSelectedCheckbox;
    }

    return disabled ? IconDisabledCheckbox : IconDefaultCheckbox;
};
